export default "__VITE_ASSET__dac95318__"